import {
  fork
} from 'redux-saga/effects';
import watchUsersActions from './usersSaga';
import watchPersonasActions from './personasSaga';

export default function* root () {
  yield fork(watchUsersActions);
  yield fork(watchPersonasActions);
}



// WEBPACK FOOTER //
// ./client/store/sagas/index.js